

/**
 * 全局删除方法
 * @param {接口地址} url
 * @param {接口参数} data
 */
export const delData = function(url, data) {
    return new Promise((resolve, reject) => {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$http.postHandle('', url, data).then(res => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
            reject()
        })
    })
}

export const backBillData = function(url, data) {
    return new Promise((resolve, reject) => {
        this.$confirm('此操作将回退该数据, 是否继续?', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$http.postHandle('', url, data).then(res => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
            reject()
        })
    })
}


/**
 * 全局操作方法
 * @param {接口地址} url
 * @param {接口参数} data
 */
export const commitData = function(messages, url, data) {
    return new Promise((resolve, reject) => {
        this.$confirm('此操作将' + messages + '该数据, 是否继续?', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$http.post(url, data).then(res => {
                this.$message({
                    type: 'success',
                    message: messages + '成功!'
                });
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
            reject()
        })
    })
}

export const localDel = function() {
    return new Promise((resolve, reject) => {
        this.$confirm('是否删除该数据?', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            resolve()
        }).catch(() => {
            reject()
        })
    })
}


/**
 * 全局关闭当前页面
 */
export const closePage = function(val) {
    return new Promise((resolve, reject) => {
        if (val === 1 || val === 2) {
            this.$confirm('此操作将不会保存填写的表单数据, 是否继续?', '提示', {
                showClose: false,
                closeOnClickModal: false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                resolve()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
                reject()
            })
        } else {
            resolve()
        }
    })
}

/**
 *
 * @param {参数(新增,编辑)} o
 */
export const submitType = function(o) {
    let obj = {
        title: '新增',
        type: 1
    };
    if (o == '新增') {
        obj = {
            title: '新增',
            type: 1
        }
    } else if (o == '编辑') {
        obj = {
            title: '编辑',
            type: 2
        }
    }
    return obj;
}

/**
 * 将数组转为字符串
 * @param {数值对象} list
 */
export const arrayToString = function(list) {
    let res = '';
    if (list) {
        res = list.toString()
    } else {
        res = ''
    }
    return res
}

/**
 * 
 * @param {字符串对象} str 
 */
export const stringToArray = function(str) {
    let res = new Array()
    if(str==null||str==""){
        return res
    }else{
        if (str.indexOf(",") < 0) {
            res.push(str)
        } else {
            res = str.split(",")
        }
        return res
    }
    
}

/**
 *
 * @param {修改前的值} value1
 * @param {修改后的值} value2
 */
export const formSetForm = function(value1, value2) {
    let form = {}
    for (let i in value1) {
        form[i] = value2[i]
    }
    return form
}



/**
 * 数组相加
 */
export const listSetList = function() {
    var valueArray=[];
    for(let n=0;n<arguments.length;n++){
      if(Array.isArray(arguments[n])){
        valueArray=valueArray.concat(arguments[n]);
      }else if(arguments[n]==null){
      }else{
        valueArray.push(arguments[n]);
      }
    }
    return valueArray;
}


/**
 * 获取图片或者文件的前缀http地址
 */
export const getConfigUrl=function(){
    return new Promise((resolve, reject) => {
        this.$http.post(this.$url.getDict, {
            search: "图片配置URL"
        }).then(res => {
            let ipPort= res.data[0].enCode;
            resolve(ipPort)
        }).catch(e=>{
            reject(e)
        })
     })
    

}


export const getExpireTime = function(contractExpireTime) {
    let today = new Date();
    let expire = contractExpireTime;
    var dateDiff=0;
    var dayDiff=0;
    if(expire==null){
    }else{
        let _expire = new Date(expire.replace(/-/g, "/")); //将-转为/
        var dateexpire = new Date(_expire); //转化为Date对象的形式
        dateDiff = dateexpire.getTime() - today.getTime(); //时间差的毫秒数
        dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
    }
    if (dateDiff <= 0) {
        return 0;
    } else {
        return dayDiff;
    }
}


    /**
     * 获取设置列表中对应Key的配置
     * @param list 配置列表
     * @param key key
     * @returns {null|Any|null} 对应key的配置
     */
export const getSetListByKey = function(list, key) {
    if (list instanceof Array) {
        for (let i = 0; i < list.length; i++) {
            let result = getSetListByKey(list[i].list || list[i].columns || list[i], key)
            if (result !== null) {
                return result
            }
        }
        return null
    } else if (list.list instanceof Array || list.columns instanceof Array) {
        return getSetListByKey(list.list || list.columns, key)
    } else {
        if (list.key === key) {
            return list
        } else {
            return null
        }
    }
}

/**
 * 通过路线id获取起止点桩号
 * @param {路线id} routeId 
 */
export const getStake = function(routeId) {
    return new Promise((resolve, reject) => {
        // this.$http.post(this.$url.route.getroutebycode, { routeId: routeId,type:'1'}).then(res => {
            let list = {
                    startStake: 0,
                    endStake: 99999
                }
            // let { data } = res;
            // list.startStake = data.startStake;
            // list.endStake = data.endStake;
            resolve(list)
        // }).catch(() => {
        //     reject()
        // })
    })
}


/**
 * 通过路线id获取起止点桩号
 * @param {路线id} routeId 
 * @param {表单JSON} formConfig(string) 
 * @param {key值} key(string) 
 */
export const setStake = function(routeId, formConfig, key, forms, bools) {
    let routeIds = routeId;
    let formConfigs = formConfig;
    let keys = key;
    if ((routeIds!="")&& formConfig && key) {
        this.getStake(routeIds).then(res => {
            if(typeof(key)=="string"){
                let stakeSet = this.getSetListByKey(this[formConfigs], keys);
                stakeSet.options.min = res.startStake;
                stakeSet.options.max = res.endStake;
                if (forms) {
                    bools ? (this[forms][key] = res.startStake) : (this[forms][key] = res.endStake);
                }
            }else if(Array.isArray(key)){
                for(let i in keys){
                    let stakeSet = this.getSetListByKey(this[formConfigs], keys[i]);
                    stakeSet.options.min = res.startStake;
                    stakeSet.options.max = res.endStake;
                    if (forms) {
                        bools[i] ? (this[forms][keys[i]] = res.startStake) : (this[forms][keys[i]] = res.endStake);
                    }
                }
            }
        })
    } else if ((routeIds === '') && formConfig && key) {
        if(typeof(key)=="string"){
            let stakeSet = this.getSetListByKey(this[formConfigs], keys);
            stakeSet.options.min = 0;
            stakeSet.options.max = 99999;
        }else if(Array.isArray(key)){
            for(let i in keys){
                let stakeSet = this.getSetListByKey(this[formConfigs], keys[i]);
                stakeSet.options.min = 0;
                stakeSet.options.max = 99999;
            }
        }
    } else {}
}




/**
 * 数字排序
 * @param {排序数组} array 
 */
export const bubbleSort = function(array) {
    if (Object.prototype.toString.call(array).slice(8, -1) === 'Array') {
        var len = array.length,
            temp;
        for (var i = 0; i < len - 1; i++) {
            for (var j = len - 1; j >= i; j--) {
                if (array[j] < array[j - 1]) {
                    temp = array[j];
                    array[j] = array[j - 1];
                    array[j - 1] = temp;
                }
            }
        }
        return array;
    } else {
        return false;
    }
}

/**
 * 深拷贝
 * @param {obj} data 
 */
export const deepCopy = function(obj) {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                //判断ojb子元素是否为对象，如果是，递归复制
                if (obj[key] && typeof obj[key] === "object") {
                    objClone[key] = deepCopy(obj[key]);
                } else {
                    //如果不是，简单复制
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;

}

/**
 * 文件导出
 * @param {地址} url 
 * @param {参数} data 
 */
export const fileDownload = function(url, data) {
   let form = {
    ...data,
       rowCodes:data.exportData.rowCodes,
	   rowCode:data.exportData.rowCode
   }
   console.log('data---------------------------')
   console.log(data)
   console.log('form---------------------------')
   console.log(form)
   if(form.rowCodes==""||form.rowCodes==null || form.rowCode =="" || form.rowCode == null){
       this.$confirm('如不勾选数据,将导出当前条件下的全部数据,是否确认?', '提示', {
           showClose: false,
           closeOnClickModal: false,
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
       }).then(() => {
           this.$http.exportFile(url,form).then(res=>{

               // const blob = new Blob([res.data],{type: "application/vnd.ms-excel"});//,{type: 'application/vnd.ms-excel;charset=utf-8'}
               const blob = new Blob([res.data],{type: "charset=utf-8"});//,{type: 'application/vnd.ms-excel;charset=utf-8'}
               let fileName = res.headers['filename'];

               const elink = document.createElement('a');

               elink.download = decodeURI(fileName);

               elink.style.display = 'none';

               elink.href = URL.createObjectURL(blob);

               document.body.appendChild(elink);

               elink.click();

               URL.revokeObjectURL(elink.href); // 释放URL 对象

               document.body.removeChild(elink);
           })
       }).catch(() => {
           this.$message({
               type: 'info',
               message: '已取消'
           });
       });
   }else{
       this.$http.exportFile(url,form).then(res=>{
           // const blob = new Blob([res.data],{type: "application/vnd.ms-excel"});//,{type: 'application/vnd.ms-excel;charset=utf-8'}
           const blob = new Blob([res.data],{type: "charset=utf-8"});//,{type: 'application/vnd.ms-excel;charset=utf-8'}
           let fileName = res.headers['filename'];

           const elink = document.createElement('a');

           elink.download = decodeURI(fileName);

           elink.style.display = 'none';

           elink.href = URL.createObjectURL(blob);

           document.body.appendChild(elink);

           elink.click();

           URL.revokeObjectURL(elink.href); // 释放URL 对象

           document.body.removeChild(elink);
       })
   }
}

/**
 * 数据批量删除
 * @param {地址} url 
 * @param {参数} data 
 */
export const selectDelete = function(url, data){
    let form = {
        rowCodes:data.exportData.rowCodes  
    }
    if(form.rowCodes==""||form.rowCodes==null){
        this.$alert('请至少勾选一条数据记录进行操作！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
        });
    }else{
        this.$confirm('此操作将永久删除该数据,是否确认?', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$http.postHandle('', url, form).then(res => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.searching();
            })
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
}

export const selectDeleteAll = function(url, data){
    let form = {
        rowCodes:data.exportData.rowCodes  
    }
    if(form.rowCodes==""||form.rowCodes==null){
        this.$alert('请至少勾选一条数据记录进行操作！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
        });
    }else{
        this.$confirm('此操作将永久删除该数据并删除同验收申请数据,是否确认?', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$http.postHandle('', url, form).then(res => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.searching();
            })
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
}

